import { resolvePartnerType, toPartnerUrlType } from './types/partnerType';

const PARTNER_URL_TYPE = /^\/partner\/([^/]+)/;

export const rewritePartnerUrlType = () => {
  const match = window.location.pathname.match(PARTNER_URL_TYPE);

  if (match === null) {
    return;
  }

  const [, urlType] = match;
  const partnerType = resolvePartnerType(urlType);

  if (partnerType === undefined) {
    return;
  }

  const canonicalUrlType = toPartnerUrlType(partnerType);

  if (canonicalUrlType === urlType) {
    return;
  }

  const pathname = window.location.pathname.replace(PARTNER_URL_TYPE, `/partner/${canonicalUrlType}`);

  window.history.replaceState({}, '', `${pathname}${window.location.search}${window.location.hash}`);
};
